import VcsDetailsPage from "../../shared/VcsShared/components/VcsDetailsPage";

const GithubDetailsPage = VcsDetailsPage;

export default GithubDetailsPage;
